import React from 'react';
import config from '../../../assets/js/conf/config.js';
import SubHeaderComponent from '../../../components/header/subheader';
import {request} from '../../../assets/js/libs/request.js';
import {lazyImg, setScrollTop} from '../../../assets/js/utils/util.js';		//图片懒加载	
import UpRefresh from "../../../assets/js/libs/uprefresh.js";

export default class NewCourse extends React.Component {
	constructor(){
		super();
		this.state = {
			fenyuanArr: []
		}
		this.Screen = true;
		this.oUpRefresh = null;
		this.curPage = 1;
		this.maxPage = 0;
		this.offsetBottom = 50;
	}
	componentDidMount(){
    	this.getJson();
       
        setScrollTop(global.scrollTop.index);
        window.addEventListener("scroll", this.isScren.bind(this),false);
    }
    getJson(val){
    	let data = {
			"pageIndex": 1,
			"pageSize": 10
    	}
    	request(config.baseUrl+'api/Study/S020', 'post', data).then(res=>{
            if (res.code == 0){
                this.setState({
                	fenyuanArr: res.data.items
                })
        		this.maxPage = res.data.totalItems;
				this.getScrollPage();
            }
        });
    }
    getScrollPage() {
		this.oUpRefresh = new UpRefresh({
			"curPage": this.curPage,
			"maxPage": this.maxPage,
			"offsetBottom": this.offsetBottom
		}, curPage => {
			if((curPage-1) * 10 >= this.maxPage){
				return
			}
			let data = {
				"pageIndex": curPage,
				"pageSize": 10
	    	}
			request(config.baseUrl+'api/Study/S020', 'post', data).then(res=>{
	            if (res.data.items.length>0){
	            	let searchArr = this.state.fenyuanArr;
					for(let i = 0; i < res.data.items.length; i++) {
						searchArr.push(res.data.items[i]);
					}
					this.setState({
						fenyuanArr: searchArr
					})
	            }
	       });
		})
	}
	componentWillUnmount(){
    	//界面离开的时候
		this.Screen = false;
		window.removeEventListener("scroll", this.isScren.bind(this));
		this.oUpRefresh = null;
		
		this.setState=(state,callback)=>{
            return;
        }
	}
	isScren(){
    	if(this.Screen){
    		let isScreen = document.documentElement.scrollTop || document.body.scrollTop;
    		global.scrollTop.index = isScreen;
	    	if(isScreen>=100){
	    		this.setState({
	    			Screen : true
	    		});
	    	}else{
	    		this.setState({
	    			Screen : false
	    		});
	    	}
    	}
    }
	LeftIcon(path){
    	this.props.history.push(path)
    }
	render() {
		return(
			<div className={'NewCourse college'}>
				<SubHeaderComponent title="最新课程"></SubHeaderComponent>
				
				<div className={'found'}>
                	<div className={'found-title-wrap'}>
                	{
                		this.state.fenyuanArr.length>0?
                		this.state.fenyuanArr.map((item2,index2) => {
                			return(
                				<div className={'found-item0 col'} onClick={this.LeftIcon.bind(this, '/video/detail?olId='+item2.Ol_ID)} key={index2}>
		                			<div className={'found-img0'}>
		                            	<img src={item2.Ol_Logo != ""?item2.Ol_Logo:require('../../../assets/images/video/pic_cover.png')} />
		                            </div>
		                            <div className={'found-txt'}>
			                            <div className={'found-title0'}>{item2.Ol_Name}</div>
			                            <div className={"found-text0"}>{item2.TeacherName}</div>
		                            </div>
		                        </div>
                			)
                		})
                        :<div className={"null"}>暂无课程内容!</div>
                	}
                		
                	</div>
                </div>
		    </div>
		);
	}
}